export default function ({ method = 'scrollBy', top }) {
  const eventStart = new Event('smoothScrollStart')
  const eventOngoing = new Event('smoothScroll')
  const eventEnd = new Event('smoothScrollEnd')

  return new Promise((resolve) => {
    const controller = {
      resolved: false,
      async begin() {
        window.dispatchEvent(eventStart)
        window.requestAnimationFrame(scrollFrame)
        await new Promise((r) => setTimeout(r, 20))
        window[method]({
          ...(top && { top }),
          behavior: 'smooth',
        })
      },
      async resolve() {
        resolve()
        this.resolved = true
        await new Promise((r) => setTimeout(r, 20))
        window.dispatchEvent(eventEnd)
      },
      get pending() {
        if (!this.resolved) window.dispatchEvent(eventOngoing)
        return !this.resolved
      },
    }

    const initialPosition = window.pageYOffset
    const fixedOffset = (method === 'scrollBy' ? initialPosition + top : top).toFixed()
    let start
    const scrollFrame = (timestamp) => {
      if (start === undefined) start = timestamp
      const elapsed = timestamp - start

      if (window.pageYOffset.toFixed() === fixedOffset || elapsed > 2000) controller.resolve()
      if (controller.pending) {
        window.requestAnimationFrame(scrollFrame)
      }
    }

    controller.begin()
  })
}
